// do not transform keys to uppercase, they are mapped with engine socket message
export const CARD_TYPES_MAP = {
  Relevant: 'cards',
  Extra: 'extraCardsList',
};
